import IApplicationState, { IRemindersState } from 'app/types/state';
import _ from 'lodash';

function mapSelect(state, n): { value: string; label: string } {
  const sa = state.reminders.remindersById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getRemindersByIdInSelectFormat(
  state: IApplicationState,
): any {
  return _.map(state.reminders.reminderIds, (n) => mapSelect(state, n));
}

export function getCurrentReminder(state: IApplicationState) {
  if (
    state.reminders.remindersById !== undefined
    && state.reminders.currentReminderId !== undefined
  ) {
    return state.reminders.remindersById[
      state.reminders.currentReminderId
    ];
  }
  return {};
}

export function getRemindersFilteredByOrganisationInSelectFormat(
  state: IApplicationState,
  organisationId,
): any {
  const { remindersById }: IRemindersState = state.reminders;
  const reminders = _.filter(remindersById, {
    organisation: { id: organisationId },
  });
  const sortedReminders = _.sortBy(reminders, (o) => o.name);
  const mappedSections = _.map(sortedReminders, (n) => mapSelect(state, n.id));
  return mappedSections;
}

export function getCurrentFormReminder(state: IApplicationState) {
  return {
    ...getCurrentReminder(state),
    ...state.reminders.requestedData,
  };
}

export function getReminder(state, reminder): any {
  if (reminder != null) {
    return {
      ...reminder,
    };
  }
  return {};
}

export function getReminderById(state, id): any {
  if (state.reminders.remindersById !== undefined && id != null) {
    return getReminder(state, state.reminders.remindersById[id]);
  }
  return {};
}

export function getReminders(state: IApplicationState) {
  return {
    ...state.reminders,
    currentReminder: {
      ...getCurrentReminder(state),
    },
    remindersByIdInSelectFormat: getRemindersByIdInSelectFormat(state),
    remindersFilteredByOrganisationInSelectFormat: (organisationId): any => getRemindersFilteredByOrganisationInSelectFormat(state, organisationId),
  };
}
